import { z } from 'zod';

export const worldlinePendingPaymentSchema = z.object({
  sessionUuid: z.uuidv4(),
  type: z.literal(['PAYMENT', 'REFUND']),
  /** Worldline payment.id */
  paymentGatewayPaymentId: z.string(),
  /** For refunds only */
  paymentGatewayRefundId: z.string().nullable().default(null),
  amountCents: z.number().int().positive(),
  last4: z.string().nullable().default(null),
  paymentGatewayPaymentMethodId: z.string().nullable().default(null),
  status: z.literal(['PENDING', 'SUCCESS', 'FAILED']),
  errorMessage: z.string().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type WorldlinePendingPayment = z.output<typeof worldlinePendingPaymentSchema>;

export const worldlinePendingPaymentCvxSchema = worldlinePendingPaymentSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type WorldlinePendingPaymentCvx = z.output<typeof worldlinePendingPaymentCvxSchema>;
